import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const DashboardHeader = styled(Box)(() => ({ 
  marginLeft:"10px",
  fontWeight: '600', 
  fontSize: '38px',
  padding: "15px",
}));